const styles = {
  paragraph: {
    letterSpacing: "0px",
    color: "#5E5E5E",
    // textTransform: "uppercase",
    fontSize: "12px",
    paddingTop: "16px",
    fontWeight: "600",
  },
  footNote: {
    letterSpacing: "0px",
    color: "#5E5E5E",
    fontSize: "11px",
    paddingTop: "16px",
    fontWeight: "600",
  },
};

export default styles;
